import { memo, useCallback } from 'react'
import { useNavigate, useLocation, createSearchParams } from 'react-router-dom'
import { ROUTES } from '@/utils'
import { Box } from '@/components/Layout'
import { Button, CurrencyAndLocation } from '@/components/Inputs'
import { useTranslations } from '@/core/translation'

import { footerStyles as styles } from './NavigationDrawerFooter.styles'
import { useAppSelector } from '@/redux/core'
import { selectIsAuthenticated } from '@/redux/auth'

const NavigationDrawerFooter = () => {
  const t = useTranslations()
  const navigate = useNavigate()
  const location = useLocation()

  const isAuthenticated = useAppSelector(selectIsAuthenticated)

  const onSignIn = useCallback(() => {
    if (isAuthenticated) navigate(ROUTES.USER.PROFILE)
    else
      navigate({
        pathname: ROUTES.LOGIN,
        search: createSearchParams({
          redirect: `${location.pathname}${location.search}`,
        }).toString(),
      })
  }, [isAuthenticated, navigate, location.pathname, location.search])

  return (
    <Box sx={styles.container}>
      <CurrencyAndLocation />

      <Button sx={styles.signInButton} onClick={onSignIn}>
        {isAuthenticated ? t('header.actions.profile') : t('header.actions.signIn')}
      </Button>
    </Box>
  )
}

export default memo(NavigationDrawerFooter)
